import { BarceloComponent } from "barcelo-components";

const FaqComponents = {
  faq: BarceloComponent({ selector: ".cmp-bhg-faq", path: "faq/faq/js/c-faq" }),
  widgetFaq: BarceloComponent({ selector: ".cmp-widget-faq", path: "faq/widget-faq/js/widget-faq" }),
};

export default FaqComponents;
